import { Colors } from '@src/colors';
import React, { FunctionComponent } from 'react';
import { Spinner } from '../../../components/Spinner';
import './submit-button.scss';
import { WireIcon } from './wire-icon';

export const SubmitButton: FunctionComponent<{
    label?: string;
    disabled?: boolean;
    onClick: (e: React.MouseEvent) => void;
    showProgress?: boolean;
    ariaLabel?: string;
    spinnerSize?: number;
}> = ({
    label,
    disabled = false,
    onClick,
    showProgress = false,
    ariaLabel = 'submit',
    spinnerSize = 36, // match value in submit-button.scss
}) => (
    <button
        data-cy="submit-button"
        disabled={disabled || showProgress}
        className={`btn btn-v-primary estimator-submit-button${label ? ' labeled' : ''}${
            showProgress ? ' show-progress' : ''
        }`}
        type="button"
        aria-label={ariaLabel}
        onClick={onClick}
        tabIndex={0}
    >
        {showProgress && (
            <div className="submit-progress">
                <Spinner size={spinnerSize} />
            </div>
        )}
        {label ? (
            label
        ) : (
            <WireIcon colorName={Colors.midnight} className="search-wire-icon" svg="arrow-right" />
        )}
    </button>
);
